"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.981 1C18.067 1 23 5.925 23 12s-4.933 11-11.019 11a11.019 11.019 0 01-10.602-8.002l4.224 1.743a3.12 3.12 0 006.174-.76l3.746-2.669.094.002a4.157 4.157 0 004.155-4.15 4.157 4.157 0 00-8.31 0v.055l-2.627 3.8a3.105 3.105 0 00-1.93.537L1 11.118C1.45 5.456 6.193 1 11.981 1zM7.833 13.938a2.336 2.336 0 012.986 3.081 2.345 2.345 0 01-3.061 1.26 2.33 2.33 0 01-1.206-1.146l1.353.558a1.724 1.724 0 002.254-.926 1.72 1.72 0 00-.928-2.25l-1.398-.577zM15.617 6.4a2.77 2.77 0 012.769 2.764 2.77 2.77 0 01-5.538 0A2.77 2.77 0 0115.617 6.4zm.004.683c-1.148 0-2.08.929-2.08 2.076s.932 2.076 2.08 2.076c1.15 0 2.08-.93 2.08-2.076a2.078 2.078 0 00-2.08-2.076z" }), "Steam");
//# sourceMappingURL=Steam.js.map